export default __webpack_public_path__ + "static/media/bannerarchywave8.593e442c.webp";